import React from "react";
import { Box, Card, CardContent, Grid, Button } from "@mui/material";
import { LoginOutlined } from "@mui/icons-material";

import "./Fonts.css";
import "./Home.css";
import { useEffect } from "react";

const Home = () => {
    // Please forgive me for this
    // This code resizes the elements of the AP cards in order to have them all aligned perfectly
    const handleResize = () => {
        let heightsAreEqual = true;
        const apSubtitles = document.getElementsByClassName("aPSubtitle");
        const apDescriptions = document.getElementsByClassName("aPDescription");
        const cardActions = document.getElementsByClassName("cardActions");
        let thisHeight = 0;
        let maxHeight = apSubtitles[0].offsetHeight;
        let heighestIndex = 0;

        // If subtitles are not of equal heights, apply margin to center descriptions
        for (let i = 1; i < apSubtitles.length; i++) {
            thisHeight = apSubtitles[i].offsetHeight;
            if (thisHeight > maxHeight) {
                heightsAreEqual = false;
                maxHeight = thisHeight;
                heighestIndex = i;
            }
        }

        if (heightsAreEqual === false) {
            for (let i = 0; i < apDescriptions.length; i++) {
                // No margin needed for the biggest card
                if (i !== heighestIndex) {
                    apDescriptions[i].style.marginTop = maxHeight + "px";
                }
            }
        } else {
            for (let i = 0; i < apDescriptions.length; i++) {
                // No margin needed for the biggest card
                if (i !== heighestIndex) {
                    apDescriptions[i].style.marginTop = 0 + "px";
                }
            }
        }

        heightsAreEqual = true;
        maxHeight = apDescriptions[0].offsetHeight;
        // If descriptions are not of equal heights, apply margin to center the action buttons
        for (let i = 1; i < apDescriptions.length; i++) {
            thisHeight = apDescriptions[i].offsetHeight;
            if (thisHeight > maxHeight) {
                heightsAreEqual = false;
                maxHeight = thisHeight;
                heighestIndex = i;
            }
        }

        if (heightsAreEqual === false) {
            for (let i = 0; i < apDescriptions.length; i++) {
                // No margin needed for the biggest card
                if (i !== heighestIndex) {
                    apDescriptions[i].parentElement.style.marginBottom =
                        maxHeight - apDescriptions[i].offsetHeight + "px";
                }
            }
        } else {
            for (let i = 0; i < apDescriptions.length; i++) {
                // No margin needed for the biggest card
                if (i !== heighestIndex) {
                    apDescriptions[i].parentElement.style.marginBottom = 0 + "px";
                }
            }
        }

        heightsAreEqual = true;
        maxHeight = cardActions[0].offsetHeight;
        // If buttons are not of equal heights, apply margin to center the action buttons
        for (let i = 1; i < cardActions.length; i++) {
            thisHeight = cardActions[i].offsetHeight;
            if (thisHeight > maxHeight) {
                heightsAreEqual = false;
                maxHeight = thisHeight;
                heighestIndex = i;
            }
        }

        if (heightsAreEqual === false) {
            for (let i = 0; i < cardActions.length; i++) {
                // No margin needed for the biggest card
                if (i !== heighestIndex) {
                    apDescriptions[i].parentElement.style.marginBottom =
                        apDescriptions[i].parentElement.style.marginBottom +
                        (maxHeight - cardActions[i].offsetHeight) / 2 +
                        "px";
                }
            }
        }
    };

    useEffect(() => {
        //handleResize();
        window.addEventListener("resize", handleResize, false);
    }, []);

    return (
        <>
            <Grid container spacing={4} className="cardsContainer">
                <Grid item lg={4}>
                    <div
                        className="clickableTitle"
                        onClick={() => {
                            window.location.href =
                                "https://ap-adriatic-public-signup.icta.fr/";
                        }}
                    >
                        <Box sx={{ minWidth: 150, height: "100%" }}>
                            <Card variant="outlined" className="aPCard">
                                <CardContent>
                                    <Grid container spacing={0} className="titleGrid">
                                        <Grid item xs={11}>
                                            <h1 className="aPTitle">Accès précoce POST-AMM</h1>
                                        </Grid>
                                        <Grid item xs={1}>
                                            <LoginOutlined className="loginIcon" />
                                        </Grid>
                                    </Grid>
                                </CardContent>
                                <CardContent>
                                    <p className="aPDescription">
                                        Cancer bronchique à petites cellules (CBPC) de stade limité
                                    </p>
                                </CardContent>
                                <CardContent>
                                    <Grid container spacing={8} className="cardActions">
                                        <Grid item xs={3} className="cardAction">
                                            <Button
                                                variant="outlined"
                                                size="large"
                                                onClick={(event) => {
                                                    window.open(
                                                        "/documents/AP ADRIATIC_PUT RD_20250623_PubliHAS.pdf",
                                                        "_blank"
                                                    );
                                                    event.stopPropagation();
                                                }}
                                                className="buttonAction buttonText"
                                            >
                                                PUT-RD
                                            </Button>
                                        </Grid>
                                        <Grid item xs={3} className="cardAction">
                                            <Button
                                                variant="outlined"
                                                size="large"
                                                onClick={(event) => {
                                                    window.open(
                                                        "/documents/AP ADRIATIC_RCP IMFINZI_AP2.pdf",
                                                        "_blank"
                                                    );
                                                    event.stopPropagation();
                                                }}
                                                className="buttonAction buttonText"
                                            >
                                                RCP
                                            </Button>
                                        </Grid>
                                        <Grid item xs={3} className="cardAction">
                                            <Button
                                                variant="outlined"
                                                size="large"
                                                onClick={(event) => {
                                                    window.open(
                                                        "/documents/AP ADRIATIC_Annexe3_Noticeinformation.pdf",
                                                        "_blank"
                                                    );
                                                    event.stopPropagation();
                                                }}
                                                className="buttonAction buttonNormalCase buttonText"
                                            >
                                                Note d'Information
                                            </Button>
                                        </Grid>
                                        <Grid item xs={3} className="cardAction">
                                            <Button
                                                variant="outlined"
                                                size="large"
                                                onClick={(event) => {
                                                    window.open(
                                                        "/documents/AP ADRIATIC_QLQ-C30.pdf",
                                                        "_blank"
                                                    );
                                                    event.stopPropagation();
                                                }}
                                                className="buttonAction buttonNormalCase buttonText"
                                            >
                                                Questionnaire QLQ-C30
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Box>
                    </div>
                </Grid>


                <Grid item lg={4}>
                    <div
                    /*    className="clickableTitle"
                        onClick={() => { window.location.href = "https://ap-matterhorn-public-signup.icta.fr/"; }}*/                    >
                        <Box sx={{ minWidth: 150, height: "100%" }}>
                            <Card variant="outlined" className="aPCard">
                                <CardContent>
                                    <Grid container spacing={0} className="titleGrid">
                                        <Grid item xs={11}>
                                            <h1 className="aPTitle">Accès précoce PRÉ-AMM</h1>
                                        </Grid>
                                        {/*<Grid item xs={1}>*/}
                                        {/*    <LoginOutlined className="loginIcon" />*/}
                                        {/*</Grid>*/}
                                    </Grid>
                                </CardContent>
                                <CardContent>
                                    <p className="aPDescription">
                                        La plateforme de l’accès précoce MATTERHORN dans le traitement de l'adénocarcinome gastrique ou de la jonction œsogastrique résécable est en cours de développement.
                                    </p>
                                </CardContent>

                            </Card>
                        </Box>
                    </div>
                </Grid>

            </Grid >
        </>
    );
};

export default Home;